<template>
  <div class="container">
    <el-form :inline="true">
      <el-form-item label="状态">
        <el-select v-model="status" placeholder="状态" clearable>
          <el-option label="报名中" :value="0"></el-option>
          <el-option label="成功" :value="1"></el-option>
          <el-option label="失败" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
        <el-button type="success" @click="addGroup">发起拼班</el-button>
      </el-form-item>
    </el-form>
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
    <template #number="{ row }">
      {{row.joined_number}}/{{row.number}}
    </template>
      <template #handler="{ row }">
        <div>
          <el-button type="primary" size="small" @click="openInfo(row)"
            >设置报名人</el-button
          >
           <el-button type="danger" size="small" @click="del(row)"
            >删除</el-button
          >
        </div>
      </template>
    </auto-table>


    
<el-dialog
  title="提示"
  :visible.sync="infoShow"
  width="30%">
  已报名人数
    <el-input v-model="count" placeholder="报名人数"></el-input>
  <span slot="footer" class="dialog-footer">
    <el-button @click="upateJoin">确认</el-button>
  
  </span>
</el-dialog>


  </div>
</template>

<script>


export default {

  data() {
    return {
      DataList: [],
      Option: [
        { name: "活动名称", value: "title" },
        { name: "报名人数", value: "number",type:"custom"},
        { name: "场馆", value: "venue_name" },
        { name: "类目", value: "categories"},
        { name: "截至时间", value: "start_time" },
        { name: "操作", value: "handler", type: "custom" },
      ],
      Total: 0,
      status: 0,
      infoShow:false,
      cur:{},
      course:{},
      stu:[],
      defaultPic:'https://img.curiousmore.com/1723426945107.png',
      count:0
    };
  },

  mounted() {
    this.getList(1);
  },

  methods: {
    openInfo(row){
        this.cur = row
       this.count = 0
        this.infoShow = true
    },
  
    del(row) {
      this.$confirm("确定删除").then(() => {
        this.$post("/shared/dgp/update", {
          id: row.id,
          status: 3,
        }).then((res) => {
          this.getList(1);
        });
      });
    },
    upateJoin() {
        
this.$post("/shared/dgp/addJoinT", {
          id: this.cur.id,
          number: this.count,
          club_id: this.cur.club_id
        }).then((res) => {
          this.getList(1);
          this.infoShow = false
        })
    },
    //获取列表
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/shared/dgp/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          status: this.status,
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.avas{
  display: flex;
  flex-wrap: wrap;

}
.ava{
    width: 40px;
    height: 40px;
    margin-right: 10px;
    margin-bottom: 10px;
}
</style>